// =======================================
// utils/throttle.js
// 高頻度イベントの負荷を抑えるためのスロットル。
// =======================================

/**
 * fn を wait(ms) 間隔で最大1回実行する（throttle）。
 * - 先頭（leading）実行あり
 * - 末尾（trailing）実行あり
 * - cancel() で予約を破棄可能
 *
 * @template {(...args: any[]) => any} F
 * @param {F} fn
 * @param {number} [wait=100]
 * @returns {F & { cancel: () => void }}
 */
export function throttle(fn, wait = 100) {
  if (typeof fn !== "function") {
    // @ts-ignore
    const noop = () => {};
    noop.cancel = () => {};
    // @ts-ignore
    return noop;
  }

  let lastTime = 0;
  let timerId = null;

  const throttled = function (...args) {
    const now = Date.now();
    const remaining = wait - (now - lastTime);

    // waitを満たしたら即実行（leading）
    if (remaining <= 0 || remaining > wait) {
      if (timerId) {
        clearTimeout(timerId);
        timerId = null;
      }
      lastTime = now;
      fn.apply(this, args);
      return;
    }

    // まだなら末尾に1回だけ予約（trailing）
    if (!timerId) {
      timerId = setTimeout(() => {
        timerId = null;
        lastTime = Date.now();
        fn.apply(this, args);
      }, remaining);
    }
  };

  throttled.cancel = () => {
    if (timerId) {
      clearTimeout(timerId);
      timerId = null;
    }
  };

  // @ts-ignore
  return throttled;
}
